<mat-form-field class="view copo-combobox-button" appearance="outline" subscriptSizing="dynamic">
	<mat-select panelClass="datacenter-tool-header-select-panel" [placeholder]="'datacenter.select-a-view' | translate" [value]="currentView" [compareWith]="viewComparator" (selectionChange)="onChange($event.value)">
		<mat-option [value]="view" *ngFor="let view of sortedViews">
			<div class="view-option-name-wrapper">
				<mat-icon class="view-option-favorite-icon" [style.visibility]="view.isFavorite === true ? 'visible' : 'hidden'" color="accent" svgIcon="favorite_heart_selected"></mat-icon>
				<span class="view-option-label">{{ view.name }}</span>
			</div>
		</mat-option>
	</mat-select>
</mat-form-field>
<button [disabled]="customizeViewDisabled" type="button" mat-stroked-button class="customize-button" (click)="onCustomize()">
	<span class="customize-button-name" translate>datacenter.customize-view</span>
	<mat-icon iconPositionEnd class="customize-button-icon" svgIcon="filters"></mat-icon>
</button>
<button type="button" mat-button class="export-result" 
		[class.downloadable]="canDownload()"
		[class.in-progress]="downloadInProgress"
		[title]="canDownload() ? ('sb.Download' | translate) : ''"
		[disabled]="!canDownload()"
		(click)="onDownload()">
	<div class="export-result-label" *ngIf="nbResults !== undefined">
		<span translate [translateParams]="{ value: nbResults | copoNumber:'number' }">datacenter.results</span>
		<span 	*ngIf="nbSelectedResults && nbSelectedResults > 0 && nbSelectedResults < nbResults" 
				translate
				[translateParams]="{ value: nbSelectedResults | copoNumber:'number' }">datacenter.selected</span>
		<ng-container *ngIf="nbSelectedResults && nbSelectedResults > 0 && nbSelectedResults >= nbResults">
			(<span translate>datacenter.all</span>)
		</ng-container>
	</div>
	<mat-icon iconPositionEnd color="accent" svgIcon="md:download" *ngIf="canDownload()"></mat-icon>
	<copo-loading-spinner *ngIf="downloadInProgress"></copo-loading-spinner>
</button>
<button	type="button"
		class="reset-filters-button"
		*ngIf="canResetFilters"
		(click)="resetFilters.emit()">
	<span class="reset-filters-button-name" translate>datacenter.reset-all-filters</span>
	<mat-icon color="accent" svgIcon="md:close"></mat-icon>
</button>